import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { useFormik } from "formik";
import { TextFieldComponent } from "components/basic/TextField";
import { SimpleDialogComponent } from "components/basic/SimpleDialog/SimpleDialog";
import { validationSchema } from "./validationSchema";
import { ButtonRound } from "../basic/Buttons";
import { submitEnquiry } from "@/pages/CheckoutInfo/checkoutInfoSlice";
import { useAppDispatch } from "@/app/hooks";
import { showNotification } from "@/components/basic/NotificationBar/notificationBarSlice";

export const EnquiryForm = forwardRef(
  (props: { registration?: string }, ref) => {
    const dialogRef = useRef();

    useImperativeHandle(ref, () => ({
      openDialog: () => {
        (dialogRef.current as any).openDialog(true);
      },
    }));

    const dispatch = useAppDispatch();

    const formik = useFormik({
      initialValues: {
        email: "",
        surname: "",
        forename: "",
        telephone: "",
        registration: props?.registration || "",
        notes: "",
      },
      validationSchema,
      onSubmit: (values, { setSubmitting }) => {
        setSubmitting(true);
        dispatch(
          submitEnquiry({
            data: values,
            continueCallback: () => {
              setSubmitting(false);
              (dialogRef.current as any).closeDialog();
              dispatch(showNotification("Submit enquiry successfully"));
            },
            failedCallback: () => {
              setSubmitting(false);
              dispatch(
                showNotification("Submit enquiry failed, please try again")
              );
            },
          })
        );
      },
    });
    const { values, errors, touched, handleChange, handleBlur, isSubmitting } =
      formik;

    return (
      <SimpleDialogComponent ref={dialogRef}>
        <form onSubmit={formik.handleSubmit} className="lg:px-32 p-8">
          <h2 className="text-2xl mb-8 text-center">Make an enquiry</h2>
          <div className="grid grid-cols-2 lg:gap-4">
            <TextFieldComponent
              name="forename"
              wrapperClassName="lg:col-span-1 col-span-full"
              className="w-full "
              label="First name"
              placeholder="First name"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.forename}
              errorMsg={touched.forename ? errors.forename : ""}
            ></TextFieldComponent>
            <TextFieldComponent
              name="surname"
              wrapperClassName="lg:col-span-1 col-span-full"
              className="w-full"
              label="Surname"
              placeholder="Surname"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.surname}
              errorMsg={touched.surname ? errors.surname : ""}
            ></TextFieldComponent>
          </div>
          <TextFieldComponent
            name="registration"
            wrapperClassName="lg:col-span-2 col-span-full"
            className="w-full"
            label="What are you looking for?"
            onChange={handleChange}
            value={values.registration}
            errorMsg={touched.registration ? errors.registration : ""}
          ></TextFieldComponent>
          <TextFieldComponent
            className="w-full"
            label="Phone number"
            placeholder="Your phone number"
            name="telephone"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.telephone}
            errorMsg={touched.telephone ? errors.telephone : ""}
          ></TextFieldComponent>
          <TextFieldComponent
            className="w-full"
            label="Email"
            placeholder="Your email address"
            onChange={handleChange}
            onBlur={handleBlur}
            name="email"
            value={values.email}
            errorMsg={touched.email ? errors.email : ""}
          ></TextFieldComponent>
          <TextFieldComponent
            className="w-full"
            label="Additional message"
            onChange={handleChange}
            onBlur={handleBlur}
            name="notes"
            value={values.notes}
            errorMsg={touched.notes ? errors.notes : ""}
            textarea
            rows={4}
          ></TextFieldComponent>
          <div className="grid grid-cols-2 gap-4 w-full mt-8">
            <ButtonRound
              buttonType="button"
              text="Back to site"
              type="black"
              className="h-10 md:col-span-1 col-span-full"
              onClick={() => {
                (dialogRef.current as any).closeDialog();
              }}
            ></ButtonRound>
            <ButtonRound
              buttonType="submit"
              text="Submit details"
              type="success"
              className="h-10 md:col-span-1 col-span-full"
              disabled={isSubmitting}
            ></ButtonRound>
          </div>
        </form>
      </SimpleDialogComponent>
    );
  }
);

export default EnquiryForm;
